import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    selector: 'snack-bar',
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.scss']
})
export class SnackBarComponent implements OnInit {
    snackBarType: any
    constructor(private _snackBarRef: MatSnackBarRef<SnackBarComponent>, @Inject(MAT_SNACK_BAR_DATA) public data: any) { }

    ngOnInit(): void { 
        this.snackBarType = this._snackBarRef.containerInstance.snackBarConfig.panelClass;
    }
}
